import { render, staticRenderFns } from "./KPolicyPrivacy.vue?vue&type=template&id=6c8f7ba8&scoped=true&"
import script from "./KPolicyPrivacy.vue?vue&type=script&lang=ts&"
export * from "./KPolicyPrivacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f7ba8",
  null
  
)

export default component.exports